// const estados = [
//   "AGUASCALIENTES",
//   "BAJA CALIFORNIA",
//   "BAJA CALIFORNIA SUR",
//   "CAMPECHE",
//   "CHIAPAS",
//   "CHIHUAHUA",
//   "CIUDAD DE MEXICO",
//   "COAHUILA",
//   "COLIMA",
//   "DURANGO",
//   "ESTADO DE MEXICO",
//   "GUANAJUATO",
//   "GUERRERO",
//   "HIDALGO",
//   "JALISCO",
//   "MICHOACAN",
//   "MORELOS",
//   "NAYARIT",
//   "NUEVO LEON",
//   "OAXACA",
//   "PUEBLA",
//   "QUERETARO",
//   "QUINTANA ROO",
//   "SAN LUIS POTOSI",
//   "SINALOA",
//   "SONORA",
//   "TABASCO",
//   "TAMAULIPAS",
//   "TLAXCALA",
//   "VERACRUZ",
//   "YUCATAN",
//   "ZACATECAS"
// ]

const  estados = [
  "COAHUILA",
  "CHIAPAS",
  "HIDALGO",
  "SAN LUIS POTOSÍ",
  "BAJA CALIFORNIA",
  "AGUASCALIENTES",
  "YUCATÁN",
  "COLIMA",
  "ZACATECAS",
  "TAMAULIPAS",
  "CHIHUAHUA",
  "MÉXICO",
  "TLAXCALA",
  "DURANGO",
  "BAJA CALIFORNIA SUR",
  "MICHOACÁN",
  "SONORA",
  "JALISCO",
  "NAYARIT",
  "GUERRERO",
  "OAXACA",
  "MORELOS",
  "PUEBLA",
  "CDMX",
  "NUEVO LEÓN",
  "QUERÉTARO",
  "CAMPECHE",
  "TABASCO",
  "SINALOA",
  "VERACRUZ",
  "QUINTANA ROO",
  "GUANAJUATO"
];

const estadosBuro = [
  "Coahuila",
  "Chiapas",
  "Hidalgo",
  "San Luis Potosi",
  "Baja California",
  "Aguascalientes",
  "Yucatan",
  "Colima",
  "Zacatecas",
  "Tamaulipas",
  "Chihuahua",
  "Mexico",
  "Estado de Mexico",
  "Tlaxcala",
  "Durango",
  "Baja California Sur",
  "Michoacan",
  "Sonora",
  "Jalisco",
  "Nayarit",
  "Guerrero",
  "Oaxaca",
  "Morelos",
  "Puebla",
  "Ciudad de Mexico",
  "Nuevo Leon",
  "Queretaro",
  "Campeche",
  "Tabasco",
  "Sinaloa",
  "Veracruz",
  "Quintana Roo",
  "Guanajuato",
];

export {
  estados,
  estadosBuro
}
